export default {
  products: {
    free: null,
    grow: 'prod_J3POowPySw4yJE',
    pro: 'prod_HHITQxe3hDhUhn',
    'app-sumo-pro': 'prod_JrByN39DU4V3ON',
    business: 'prod_GANSglVKDdJSS7',
    premium: 'prod_GANRHTJdK4hyaE',
    'base-premium': 'prod_I7spIzDx8pa5Uy'
  },
  plans: {
    // old plans
    free: null,
    // 'researcher-monthly': 'plan_HHITwsmnJYR8vg',
    // 'researcher-annual': 'plan_HHITIk2R7ZmV3q',
    // 'pro-monthly': 'plan_GANSxtAUJvioMs',
    // 'pro-annual': 'plan_HHIS4waZ7h8T4J',
    // 'business-monthly': 'plan_GANREWmH1h04E0',

    /** Renamed old admin's trial plans */
    'pro-admin-trial': 'price_HK7DTN8FSF3wbh',
    'business-admin-trial': 'price_HK7EnsRURNHGmj',
    'premium-admin-trial': 'price_HK7Fg8Mu7CHJGD',

    /* New plans **/

    // 0. Grow
    'grow-monthly': 'price_1IRIZwJ1GI5FYk3yjiIaVWnQ',
    'grow-annual': 'price_1IRIZwJ1GI5FYk3yclNzvHPU',
    // 0.1 Grow GBP
    'grow-monthly-gbp': 'price_1IRIZwJ1GI5FYk3yEJmMlQ3s',
    'grow-annual-gbp': 'price_1IRIZwJ1GI5FYk3yMqAqbIby',

    // 1. Pro
    'pro-monthly': 'price_1HFbo4J1GI5FYk3yRXCSrCdy',
    'pro-annual': 'price_1HFboUJ1GI5FYk3yxqsaXiQL',
    // 1.1 Pro GBP
    'pro-monthly-gbp': 'price_1HFbpHJ1GI5FYk3yzyZrJo1K',
    'pro-annual-gbp': 'price_1HFbpnJ1GI5FYk3ymeNZGv6L',

    // 1.2 Pro App Sumo
    'app-sumo-pro-annual': 'app-sumo-plan',

    // 1.3 CartLoop Plan
    'cartloop-pro-monthly': 'cartloop-plan',

    // 2. Business
    'business-monthly': 'price_1HD4ZjJ1GI5FYk3ycAoi8ZRx',
    'business-annual': 'price_1HD4aHJ1GI5FYk3ytBoCjAWQ',
    // 2.1 Business GBP
    'business-monthly-gbp': 'price_1HD4azJ1GI5FYk3yjsWdSteH',
    'business-annual-gbp': 'price_1HD4bcJ1GI5FYk3ykwfx1fCJ',

    // 3. Enterprise Base Premium
    'base-premium-monthly-gbp': 'price_1HXd45J1GI5FYk3yYXWmNzQo'
  }
}
